module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "firewall-key.ba57f72c.svg";